<div class="form-page">
  <div class="form-page-chess" aria-hidden="true"></div>
  <div class="form-page-image" aria-hidden="true"></div>

  <div class="form-page-frame">
    <div class="form-page-row">
      <div class="form-page-visual">
        <div class="form-page-visual-stack">
          <div class="form-page-visual-top">
            <button type="button" class="form-page-back-btn" (click)="redirectTo('subscriber-login')">
              <i class="fas fa-arrow-left" aria-hidden="true"></i>
              <span>Back</span>
            </button>

            <img
              class="form-page-visual-logo"
              src="assets/images/login-logo.svg"
              alt="A Square ERP Solutions"
              width="234"
              height="48"
            />
          </div>

          <div class="form-page-visual-copy">
            <h2>Stand Out with Smarter Operations.</h2>
            <p>Bring every process together with A-Square ERP, from production and inventory to sales, finance, and reporting.</p>
          </div>
        </div>
      </div>

      <div class="form-page-panel">
        @if (subscriberformGroup) {
          <form class="signup-form figma-auth-form" [formGroup]="subscriberformGroup" (ngSubmit)="SubscriberSignUp()">
            <div class="signup-form-main">
              <div class="signup-header">
                <div class="signup-heading">
                  <h3>Create your Asquare ERP Account</h3>
                  <p>Enter your details to set up your business workspace.</p>
                </div>
                <div class="signup-header-divider" aria-hidden="true"></div>
              </div>

              <div class="signup-scroll">
                <div class="signup-scroll-inner">
                  <button type="button" class="signup-google-btn" (click)="onGoogleSignUpClick()">
                    <svg class="signup-google-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M22.5015 12.2332C22.5015 11.3699 22.43 10.7399 22.2753 10.0865H12.2158V13.9832H18.1205C18.0015 14.9515 17.3587 16.4099 15.9301 17.3898L15.91 17.5203L19.0907 19.935L19.311 19.9565C21.3348 18.1249 22.5015 15.4298 22.5015 12.2332Z" fill="#4285F4"/>
                      <path d="M12.215 22.5C15.1078 22.5 17.5363 21.5666 19.3102 19.9566L15.9292 17.3898C15.0245 18.0082 13.8102 18.4399 12.215 18.4399C9.38167 18.4399 6.97693 16.6082 6.11971 14.0765L5.99406 14.087L2.68681 16.5954L2.64355 16.7132C4.40543 20.1432 8.02448 22.5 12.215 22.5Z" fill="#34A853"/>
                      <path d="M6.11997 14.0766C5.89379 13.4233 5.76289 12.7232 5.76289 11.9999C5.76289 11.2765 5.89379 10.5766 6.10807 9.92325L6.10208 9.78411L2.75337 7.23547L2.64381 7.28655C1.91765 8.7099 1.50098 10.3083 1.50098 11.9999C1.50098 13.6916 1.91765 15.2899 2.64381 16.7132L6.11997 14.0766Z" fill="#FBBC05"/>
                      <path d="M12.215 5.55997C14.2269 5.55997 15.584 6.41163 16.3579 7.12335L19.3817 4.23C17.5246 2.53834 15.1078 1.5 12.215 1.5C8.02451 1.5 4.40544 3.85665 2.64355 7.28662L6.10783 9.92332C6.97696 7.39166 9.38171 5.55997 12.215 5.55997Z" fill="#EB4335"/>
                    </svg>
                    <span class="signup-google-label">Continue with Google</span>
                  </button>
                  @if (!platform.is('capacitor')) {
                    <div class="signup-google-hidden" id="google-signup" aria-hidden="true"></div>
                  }

                  <div class="signup-or">
                    <span></span>
                    <p>or create account with email</p>
                    <span></span>
                  </div>

                  <div class="signup-fields">
                    @if (isShowErrorMessage) {
                      <p class="signup-status-text">Please fill all required fields</p>
                    }

                    <div class="signup-field-row">
                      <div class="field-item">
                        <label for="signup-first-name">First Name*</label>
                        <div class="figma-input">
                          <input
                            type="text"
                            class="figma-input-field"
                            id="signup-first-name"
                            placeholder="First Name"
                            formControlName="FirstName"
                            autocomplete="given-name"
                            data-initial-focus
                          />
                        </div>
                      </div>

                      <div class="field-item">
                        <label for="signup-last-name">Last Name*</label>
                        <div class="figma-input">
                          <input
                            type="text"
                            class="figma-input-field"
                            id="signup-last-name"
                            placeholder="Last Name"
                            formControlName="LastName"
                            autocomplete="family-name"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="signup-field-row">
                      <div class="field-item field-item--helper">
                        <label for="signup-mobile">Mobile Number*</label>
                        <div class="figma-input">
                          <input
                            type="tel"
                            class="figma-input-field"
                            id="signup-mobile"
                            #mobileNumber
                            maxlength="10"
                            placeholder="Enter mobile number"
                            formControlName="MobileNumber"
                          />
                        </div>
                        <button type="button" class="field-action" (click)="sendOTP()">Send OTP</button>
                        @if (isOTPSent) {
                          <span class="field-success"><i class="fas fa-check-circle" aria-hidden="true"></i> OTP sent</span>
                        }
                      </div>

                      <div class="field-item field-item--helper">
                        <label for="signup-otp">OTP*</label>
                        <div class="figma-input">
                          <input
                            type="text"
                            class="figma-input-field"
                            id="signup-otp"
                            maxlength="4"
                            placeholder="Enter OTP"
                            formControlName="OTP"
                          />
                        </div>
                        <button type="button" class="field-action" (click)="confirmOTP()">Confirm</button>
                        @if (isOTPSent && isOTPValid === false) {
                          <span class="field-error">Invalid OTP</span>
                        }
                        @if (isOTPSent && isOTPValid === true) {
                          <span class="field-success"><i class="fas fa-check-circle" aria-hidden="true"></i> Verified</span>
                        }
                      </div>
                    </div>

                    <div class="signup-field-row signup-field-row--full">
                      <div class="field-item field-item--full">
                        <label for="signup-email">Email*</label>
                        <div class="figma-input">
                          <input
                            type="email"
                            class="figma-input-field"
                            id="signup-email"
                            placeholder="Enter email"
                            formControlName="EmailID"
                            autocomplete="email"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="signup-field-row signup-field-row--address">
                      <div class="field-item field-item--textarea">
                        <label for="signup-address">Address</label>
                        <div class="figma-input figma-input--textarea">
                          <textarea
                            class="figma-input-field figma-input-textarea"
                            id="signup-address"
                            placeholder="Enter address"
                            formControlName="Address"
                            autocomplete="street-address"
                            rows="6"
                          ></textarea>
                        </div>
                      </div>

                      <div class="signup-field-stack">
                        <div class="field-item">
                          <label for="signup-state">State</label>
                          <div class="figma-input">
                            <input
                              type="text"
                              class="figma-input-field"
                              id="signup-state"
                              placeholder="State"
                              formControlName="State"
                              autocomplete="address-level1"
                            />
                          </div>
                        </div>

                        <div class="field-item">
                          <label for="signup-city">City</label>
                          <div class="figma-input">
                            <input
                              type="text"
                              class="figma-input-field"
                              id="signup-city"
                              placeholder="City"
                              formControlName="City"
                              autocomplete="address-level2"
                            />
                          </div>
                        </div>

                        <div class="field-item">
                          <label for="signup-pincode">Pin Code</label>
                          <div class="figma-input">
                            <input
                              type="text"
                              class="figma-input-field"
                              id="signup-pincode"
                              maxlength="6"
                              placeholder="Pin Code"
                              formControlName="PinCode"
                              autocomplete="postal-code"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="signup-field-row">
                      <div class="field-item">
                        <label for="signup-gst">GST Number</label>
                        <div class="figma-input">
                          <input
                            type="text"
                            class="figma-input-field"
                            id="signup-gst"
                            placeholder="GST Number"
                            formControlName="GstNo"
                          />
                        </div>
                      </div>

                      <div class="field-item">
                        <label for="signup-business-type">Business Type*</label>
                        <p-select
                          inputId="signup-business-type"
                          class="signup-select"
                          formControlName="BusinessType"
                          [options]="businessTypeOptions"
                          optionLabel="label"
                          optionValue="value"
                          appendTo="body"
                        ></p-select>
                      </div>
                    </div>

                    <div class="signup-field-row">
                      <div class="field-item">
                        <label for="signup-password">Password*</label>
                        <div class="figma-input">
                          <input
                            [type]="hide ? 'password' : 'text'"
                            class="figma-input-field"
                            id="signup-password"
                            placeholder="Password"
                            formControlName="Password"
                            autocomplete="new-password"
                          />
                          <button
                            type="button"
                            class="figma-input-toggle"
                            (click)="hide = !hide"
                            [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
                          >
                            <i class="fas" [class.fa-eye]="hide" [class.fa-eye-slash]="!hide" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>

                      <div class="field-item">
                        <label for="signup-confirm-password">Confirm Password*</label>
                        <div class="figma-input">
                          <input
                            [type]="confirmhide ? 'password' : 'text'"
                            class="figma-input-field"
                            id="signup-confirm-password"
                            placeholder="Confirm Password"
                            formControlName="ConfirmPassword"
                            autocomplete="new-password"
                          />
                          <button
                            type="button"
                            class="figma-input-toggle"
                            (click)="confirmhide = !confirmhide"
                            [attr.aria-label]="confirmhide ? 'Show password' : 'Hide password'"
                          >
                            <i class="fas" [class.fa-eye]="confirmhide" [class.fa-eye-slash]="!confirmhide" aria-hidden="true"></i>
                          </button>
                        </div>
                        @if (isPasswordNotMatch) {
                          <span class="field-error">Password not matched. Please try again.</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <button class="signup-submit-btn" type="submit">
                <span class="signup-submit-btn-label">Create Account</span>
              </button>

              @if (isEmailIDExist) {
                <p class="signup-status-text">Email-ID already exists. Please try again.</p>
              }

              <p class="signup-login-footer">
                Already have an account?
                <a (click)="redirectTo('subscriber-login')">Log in</a>
              </p>
            </div>
          </form>
        }

        <button type="button" class="form-page-info-btn" aria-label="Information" hidden>
          <i class="fas fa-info-circle" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</div>
